// Vendors
import { CharactersEnumeration } from '@gruposantander/opbpay-ui-core-models';
import { CountriesLocaleEnumeration } from '@gruposantander/opbpay-ui-core-models';
// Constants
import {
  CALLBACK_URL_QUERY_PARAM,
  LANGUAGE_QUERY_PARAM,
} from 'providers/token/handlers/constants/token.handlers.constants';

const getCheckoutIdFromUrl = (): string => {
  const checkoutIdFromPath = window.location.pathname.split(CharactersEnumeration.SLASH)[1];
  if (!checkoutIdFromPath) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const checkoutIdFromQuery = urlSearchParams.get('orderId');
    return checkoutIdFromQuery || '';
  }

  return checkoutIdFromPath;
};

const getCallbackUrlFromQueryParams = (): string => {
  const callbackUrl =
    new URLSearchParams(window.location.search).get(CALLBACK_URL_QUERY_PARAM) || '';

  return callbackUrl ? callbackUrl.trim() : '';
};

const getLanguageFromUrl = (): string => {
  const language = new URLSearchParams(window.location.search).get(LANGUAGE_QUERY_PARAM) || '';

  return [CountriesLocaleEnumeration.SPAIN, CountriesLocaleEnumeration.ENGLAND].includes(
    language as CountriesLocaleEnumeration
  )
    ? language
    : CountriesLocaleEnumeration.SPAIN;
};

const DANGEROUS_KEYS = ['__proto__', 'constructor', 'prototype'];

const getQueryParamsFromUrl = (): Record<string, string> => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const filteredEntries = Array.from(urlSearchParams.entries()).filter(
    ([key]) => !DANGEROUS_KEYS.includes(key)
  );

  return Object.fromEntries(filteredEntries);
};

const replaceUrlPathWithOrderId = (orderId?: string, callbackUrl?: string): void => {
  if (orderId) {
    const searchParams = new URLSearchParams(window.location.search);
    const language = searchParams.get(LANGUAGE_QUERY_PARAM);
    const query = [
      callbackUrl && `${CALLBACK_URL_QUERY_PARAM}=${callbackUrl}`,
      language && `${LANGUAGE_QUERY_PARAM}=${language}`,
    ]
      .filter(Boolean)
      .join('&');
    window.history.replaceState(
      {},
      '',
      `${CharactersEnumeration.SLASH}${orderId}${query ? `?${query}` : ''}`
    );
  }
};

export {
  replaceUrlPathWithOrderId,
  getCheckoutIdFromUrl,
  getCallbackUrlFromQueryParams,
  getLanguageFromUrl,
  getQueryParamsFromUrl,
};
